var _mask, _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_2234_1113",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 18,
    height: 20,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 3,
    y: 2,
    width: 18,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3H20V6L14 13V18L10 21V13L4 6V3Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3H20V6L14 13V18L10 21V13L4 6V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 3H21C21 2.44772 20.5523 2 20 2V3ZM4 3V2C3.44772 2 3 2.44772 3 3H4ZM20 6L20.7593 6.65079C20.9146 6.46955 21 6.23871 21 6H20ZM14 13L13.2407 12.3492C13.0854 12.5305 13 12.7613 13 13H14ZM14 18L14.6 18.8C14.8518 18.6111 15 18.3148 15 18H14ZM10 21H9C9 21.3788 9.214 21.725 9.55279 21.8944C9.89157 22.0638 10.297 22.0273 10.6 21.8L10 21ZM10 13H11C11 12.7613 10.9146 12.5305 10.7593 12.3492L10 13ZM4 6H3C3 6.23871 3.08539 6.46955 3.24074 6.65079L4 6ZM20 2H4V4H20V2ZM21 6V3H19V6H21ZM14.7593 13.6508L20.7593 6.65079L19.2407 5.34921L13.2407 12.3492L14.7593 13.6508ZM13 13V18H15V13H13ZM13.4 17.2L9.4 20.2L10.6 21.8L14.6 18.8L13.4 17.2ZM11 21V13H9V21H11ZM3.24074 6.65079L9.24074 13.6508L10.7593 12.3492L4.75926 5.34921L3.24074 6.65079ZM3 3V6H5V3H3Z",
    fill: "#797979",
    mask: "url(#path-1-outside-1_2234_1113)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 14,
    height: 2,
    fill: "#E57200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.efe34d14236975db99dfad016eb7dbed.svg";
export { ForwardRef as ReactComponent };